import React, { useEffect, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import styles from "./failedverification.module.css";
import { EMAIL_SEND_ENDPOINT } from "../../CONSTANTS";

function FailedVerification({ handleClose, client }) {
  const [emailAddress, setEmailAddress] = useState()
  const [error, setError] = useState(false)
  const sendNewEmail = () => {
    client.post(EMAIL_SEND_ENDPOINT, { emailAddress })
        .then(data => {
            handleClose()
        })
        .catch(err => setError(true))
  }

  const handleEmailChange = (e) => {
    setEmailAddress(e.target.value);
  }

  useEffect(() => {
      setTimeout(() => {
          setError(false)
      },10000)
  }, [error])

  return (
    <div className={[styles.fail_container, "box-container"].join(" ")}>
      <div>
        <AiOutlineCloseCircle
          color="#3778EB"
          style={{ height: "100px", width: "100px" }}
        />
        <h2>Email verification failed</h2>
        <p>The link used was not valid or has expired</p>
      </div>
      <div className="App-input-container">
        <input type="email" className="resend-input" required onChange={handleEmailChange} />
      </div>
      <div>
        <button onClick={sendNewEmail}>
          Resend Verification Email
        </button>
      </div>
        {error ? <i style={{color:"#f00"}}>Please verify your input and retry</i>:<></>}
    </div>
  );
}

export default FailedVerification;
